import APIConfig from "./APIConfig";
import axiosClient from "../app/axiosConfig";

class UtilityService {
  getFormattedAddressFromCoordinates = (body) => {
    const url = APIConfig.utilityService.getFormattedAddressFromCoordinates;
    return axiosClient.post(url, body);
  };

  placesAutocomplete = (body) => {
    const url = APIConfig.utilityService.placesAutocomplete;
    return axiosClient.post(url, body);
  };

  getCoordinatesFromPlace = (body) => {
    const url = APIConfig.utilityService.getCoordinatesFromPlace;
    return axiosClient.post(url, body);
  };
}

const utilityService = new UtilityService();
export default utilityService;
